export default __webpack_public_path__ + "static/google-edit-6dfb43c0461478984000becff734aac5.svg";